import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

class Ims extends Component {
    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'ims'}
            title={'PROCEDURE P1.0 INTEGRATED MANAGEMENT REVIEW'}
            exportTitle={'<h2>Procedure P1.0 Integrated management review</h2>'}
            exportFileName={'ims.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Ims);
